import Css from "./style.module.scss";

import * as Icons from "@phosphor-icons/react";
import { getAccountsData } from "selectors/accounts";
import { getCurrentQuickBooksRealmId } from "selectors/businesses";
import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import DateRangePickerExtended from "nlib/common/DateRangePickerExtended";
import DebounceInput from "nlib/ui/DebounceInput";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import Row from "nlib/ui/Row";
import Select from "nlib/ui/Select";
import classNames from "classnames";

const Filters = ({ className, disabled, filters, onChange }) => {
  const { uiTexts } = useSelector(getTextsData);

  const quickBooksBusiness = !!useSelector(getCurrentQuickBooksRealmId);

  const accountsData = useSelector(getAccountsData);

  const {
    text = "",
    fromDate = "",
    toDate = "",
    accountId
  } = filters;

  const [textInputValue, setTextInputValue] = useState(text);

  const fromToDate = useMemo(() => [fromDate, toDate], [fromDate, toDate]);

  const accountOptions = useMemo(() => [
    accountId && { label: uiTexts.all },
    ...accountsData
      .filter(({ extraData: { paymentAccount } = {} }) => !quickBooksBusiness || paymentAccount)
      .map(({ id, name, accountNumber }) => ({
        value: id,
        label: name || accountNumber
      }))
  ], [accountId, accountsData, quickBooksBusiness, uiTexts.all]);

  const handleTextInputComplete = useCallback((value) => {
    onChange({ text: value || null });
  }, [onChange]);

  const handleDateChange = useCallback((value) => {
    const [from, to] = Array.isArray(value) ? value : [];

    onChange({ fromDate: from ?? "", toDate: to ?? "" });
  }, [onChange]);

  const handleAccountChange = useCallback((value) => {
    onChange({ accountId: value });
  }, [onChange]);

  useEffect(() => {
    setTextInputValue(text || "");
  }, [text]);

  return (
    <div className={classNames(Css.filters, className)}>
      <Row>
        <DebounceInput
          cleanable
          disabled={disabled}
          active={!!text}
          className={Css.search}
          placeholder={uiTexts.searchTransactions}
          value={textInputValue}
          onChange={setTextInputValue}
          onInputComplete={handleTextInputComplete}
          iconBefore={Icons.MagnifyingGlass} />

        <Select
          disabled={disabled}
          active={!!accountId}
          value={accountId}
          className={Css.account}
          placeholder={uiTexts.selectAccount}
          iconBefore={Icons.CreditCard}
          options={accountOptions}
          onChange={handleAccountChange} />

        <DateRangePickerExtended
          range
          active={!!fromDate && !!toDate}
          value={fromToDate}
          className={Css.dateRange}
          placeholder={uiTexts.selectDate}
          onChange={handleDateChange} />
      </Row>
    </div>
  );
};

export default React.memo(Filters);
